import React, { useMemo } from "react";
import _ from "lodash";
import AppConstants from "../../constants/AppConstants";
import { FRAME_CSS } from "../../constants/FrameConstants";
import ThemeCSSGenerator from "../utils/ThemeCSSGenerator";

const PageHeader = ({
  designContext,
  layout,
  layoutWidth,
  theme,
  pageStyle,
}) => {
  let tags = [];

  const paddingTop = _.get(pageStyle, "paddingTop", AppConstants.STAGE_PADDING);
  const paddingBottom = _.get(
    pageStyle,
    "paddingBottom",
    AppConstants.STAGE_PADDING,
  );

  let css = FRAME_CSS.resetCSS;

  let contentStyle = "position:relative;";
  contentStyle += `width:${layoutWidth}px;`;
  // Shifts design portion of stage to center. Auto was causing issues.
  contentStyle += `margin-left:var(--page-offset-x, 0px);`;
  contentStyle += `margin-top:${paddingTop}px;`;
  contentStyle += `margin-bottom:${paddingBottom}px;`;
  css += ` #si_page_content {${contentStyle}}`;
  css += ` #render-mount{-webkit-text-size-adjust:none;text-size-adjust:none;}`;

  // Add placeholder background styles
  const placeholderCSS = `
    .contentContainer {
      display: flex;
      flex-direction: column;
      width: 100%;
      padding: 10px;
    }
    .iconContainer {
      display: block;
      color: #fff;
      font-weight: 700;
    }
    .placeholderText {
      display: block;
      margin-bottom: 10px;
    }
    .placeholderContainer {
      background-color: #333;
      background-image: url("data:image/svg+xml;utf8,<svg version='1.1' xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 40 40' enableBackground='new 0 0 40 40' ><g fill='rgba(255,255,255,0.04)'><polygon points='40,40 40,20 20,40'/><polygon points='0,20 20,0 40,0 0,40'/></g></svg>");
      background-size: 10px 10px;
      color: rgb(189, 189, 189);
      font-family: "Inter", sans-serif;
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      text-align: center;
      align-items: center;
      container-type: size;
      container-name: placeholder-container;
      box-shadow: rgba(0, 0, 0, 0.4) 0 0 10px inset;
    }
    /* Hide text when container is smaller than 200px wide or 130px tall */
    @container placeholder-container (max-width: 199px) {
      .placeholderText {
        display: none;
      }
    }
    @container placeholder-container (max-height: 129px) {
      .placeholderText {
        display: none;
      }
    }
  `
    .replace(/\s+/g, " ")
    .trim();
  css += placeholderCSS;

  const themeInfo = useMemo(
    () => ThemeCSSGenerator.generate(theme, layout, designContext),
    [theme, layout, designContext],
  );
  tags = tags.concat(themeInfo.tags);
  css += themeInfo.css;

  tags.push(
    <style
      key="page-style"
      id="si_page_style"
      type="text/css"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: css }}
    />,
  );

  return (
    <div id="si_page_header" style={{ display: "none" }}>
      {tags}
    </div>
  );
};

export default PageHeader;
